import { PageLocatorMap } from '../types/PageLocatorMap';

export const applySearchModelPage = {
  alert: {
    error: 'apply-search-model-page.form.alert.error',
  },
  footer: {
    root: 'apply-search-model-page.footer.root',
  },
  form: {
    accessibilitySubmit:
      'apply-search-model-page.form.keyboard-only-submit-button',
    getRadioOption: (index: number): string =>
      `apply-search-model-page.form.radio-option-${index + 1}`,
    h1: 'apply-search-model-page.form.h1',
    h2: 'apply-search-model-page.form.h2',
    radioGroupRoot: 'apply-search-model-page.form.radio-group-root',
    root: 'apply-search-model-page.form.root',
  },
  header: {
    drawerButton: 'apply-search-model-page.header.drawer-button',
    previousStepButton: 'apply-search-model-page.header.previous-step-button',
    root: 'apply-search-model-page.header.root',
  },
  progress: {
    root: 'apply-search-model-page.progress.root',
  },
} as const satisfies PageLocatorMap;
